"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iframeFix = exports.RichText = exports.CanvasPlayer = void 0;
var Interfaces = require("./interfaces");
var ios_fix_js_1 = require("./ios-fix.js");
var noSleep_js_1 = require("./noSleep.js");
var rich_text_js_1 = require("./rich-text.js");
exports.RichText = rich_text_js_1.default;
var createjs_1 = require("createjs");
var customevent_ie_js_1 = require("./customevent-ie.js");
var debounce_js_1 = require("./debounce.js");
var iframe_fix_js_1 = require("./iframe-fix.js");
Object.defineProperty(exports, "iframeFix", { enumerable: true, get: function () { return iframe_fix_js_1.iframeFix; } });
var createJSFixed = false;
var animationCache = {};
function fakeSynced(_asset, currentFrame) {
    var asset = _asset;
    asset._getStartFrame = function () {
        if (typeof this._startFrame === "number")
            return this._startFrame;
        this._startFrame = currentFrame;
        return this._startFrame;
    };
    asset.advance = function () {
        this._framerate = this.framerate;
        return;
    };
    asset._updateTimeline = function (rawPosition, jump) {
        var tl = this.timeline;
        if (!this.parent)
            return;
        rawPosition = this.parent.currentFrame - this._getStartFrame();
        if (rawPosition < 0) {
            rawPosition = 0;
        }
        if (this._rawPosition === rawPosition) {
            return;
        }
        this._rawPosition = rawPosition;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tl.loop = this.loop;
        var movingBackwards = tl.rawPosition >= rawPosition;
        tl.setPosition(rawPosition, movingBackwards || !this.actionsEnabled, jump, this._bound_resolveState);
    };
}
var CanvasPlayer = /** @class */ (function (_super) {
    __extends(CanvasPlayer, _super);
    function CanvasPlayer(container, animation, options) {
        var _this = _super.call(this) || this;
        _this.noSleepInstance = null;
        _this.tickHandler = function (event) {
            if (document.hidden) {
                return;
            }
            if (_this.exportRoot.currentFrame >= _this.exportRoot.duration && !_this.ended) {
                _this.ended = true;
                _this.audioClips.forEach(function (clip) {
                    clip.soundInstance.stop();
                });
                if (_this.backgroundMusicSoundClip) {
                    _this.backgroundMusicSoundClip.soundInstance.position = 0;
                    _this.backgroundMusicSoundClip.soundInstance.volume = 1;
                }
                _this.dispatchEvent("ended");
            }
            if (!_this.stage) {
                return;
            }
            // REMOVED - prevents animation when the player is paused.
            // this.stage.tickOnUpdate = !this.paused;
            var time = (_this.exportRoot.currentFrame * 1000) / _this.animationProperties.fps;
            if (time !== _this.lastReportedTime) {
                _this.lastReportedTime = time;
                _this.fadeOutBackgroundMusic();
                _this.dispatchEvent("timeupdate");
            }
            if (!_this.paused) {
                _this.loopThroughAudio(_this.exportRoot.currentFrame);
            }
            if (_this.captions.length !== 0 && _this.enableCC) {
                var currentCaptionIndex = _this.currentCaptionsReference === undefined ? -1 : _this.captions.indexOf(_this.currentCaptionsReference);
                if (currentCaptionIndex === -1) {
                    _this.currentCaptionsReference = _this.captions[0];
                    var event_1 = new CustomEvent("captionChanged", {
                        detail: _this.currentCaptionsReference,
                    });
                    _this.dispatchEvent(event_1);
                }
                else if (_this.captions[currentCaptionIndex + 1] !== undefined &&
                    _this.exportRoot.currentFrame >= _this.captions[currentCaptionIndex + 1].startFrame) {
                    _this.currentCaptionsReference = _this.captions[currentCaptionIndex + 1];
                    var event_2 = new CustomEvent("captionChanged", {
                        detail: _this.currentCaptionsReference,
                    });
                    _this.dispatchEvent(event_2);
                }
            }
            _this.stage.update(event);
            if (typeof _this.exportRoot.handleSoundTick === "function") {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                _this.exportRoot.handleSoundTick();
            }
        };
        if (typeof options.noSleep === "undefined" || options.noSleep) {
            _this.noSleepInstance = noSleep_js_1.default.get();
        }
        createjs_1.default.EventDispatcher.initialize(_this);
        _this.iosFixed = false;
        _this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (_this.isIOS) {
            _this.implementIOSFix();
        }
        if (!createJSFixed) {
            _this.implementCreateJSFix();
        }
        _this.container = container;
        _this.animation = animation;
        _this.options = options;
        if (_this.animation instanceof Array) {
            _this.loadChildrenLibraries();
        }
        else {
            _this.animationLibrary = _this.animation.composition.getLibrary();
            _this.animationImages = _this.animation.composition.getImages();
        }
        _this.animationProperties = _this.animationLibrary.properties;
        var preloadFonts = _this.options.fonts || [];
        if (_this.container.querySelector("canvas") === null) {
            _this.container.appendChild(_this.createTemplate(preloadFonts));
        }
        _this.initializeOptions();
        // Load the files from the manifest
        if (_this.manifest.length > 0) {
            _this.handleAnimationLoad(_this.animation instanceof Array ? _this.animation : [_this.animation]);
        }
        else {
            setTimeout(function () { return _this.handleComplete(); });
        }
        // Creating the debounced version of resize function
        _this.handleResizeDebounced = (0, debounce_js_1.rmDebounce)(_this.handlePlayerResize.bind(_this), 50, false);
        _this.fullScreenFunc = function () {
            _this.fullScreenChange();
        };
        _this.resizeFunc = function () {
            _this.handleResize();
        };
        document.addEventListener("fullscreenchange", _this.fullScreenFunc);
        document.addEventListener("mozfullscreenchange", _this.fullScreenFunc);
        document.addEventListener("webkitfullscreenchange", _this.fullScreenFunc);
        document.addEventListener("MSFullscreenChange", _this.fullScreenFunc);
        window.addEventListener("resize", _this.resizeFunc);
        _this.dispatchEvent("loadstart");
        return _this;
    }
    Object.defineProperty(CanvasPlayer.prototype, "paused", {
        /**
         * Getter that is used to obtain the exportRoot.paused value
         */
        get: function () {
            return this.exportRoot === undefined ? true : this.exportRoot.paused;
        },
        enumerable: false,
        configurable: true
    });
    // Fixes line height issue for dynamic texts.
    CanvasPlayer.prototype.implementCreateJSFix = function () {
        createJSFixed = true;
        var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
        var isios = /iPad|iPhone|iPod/.test(navigator.userAgent);
        var appleTextFix = false;
        var isChromeGreaterThanOrEqualTo71 = true;
        try {
            var versionNumber = navigator.userAgent.match(/Chrome\/(\d+)/i)[1];
            isChromeGreaterThanOrEqualTo71 = Number(versionNumber) >= 71;
        }
        catch (error) {
            isChromeGreaterThanOrEqualTo71 = false;
        }
        if (/Mac/i.test(navigator.userAgent) && !isios) {
            var macSafariVersion = Number(navigator.userAgent.match(/Version\/(\d+)/i)[1]);
            if (macSafariVersion < 16)
                appleTextFix = true;
        }
        if (isios) {
            var iosSafariVersion = Number(navigator.userAgent.match(/Version\/(\d+)/i)[1]);
            if (iosSafariVersion < 16)
                appleTextFix = true;
        }
        if (isFirefox || isChromeGreaterThanOrEqualTo71 || appleTextFix) {
            var createJSTextPrototype = createjs_1.default.Text.prototype;
            var prepContext_1 = createJSTextPrototype._prepContext;
            createJSTextPrototype._prepContext = function (context) {
                var workingContext = createjs_1.default.Text._workingContext;
                workingContext.save();
                var measuredWidth = prepContext_1.call(this, workingContext).measureText("M").width * 1.2;
                workingContext.restore();
                context.translate(0, measuredWidth * 0.2);
                return prepContext_1.call(this, context);
            };
        }
    };
    CanvasPlayer.prototype.implementIOSFix = function () {
        var _this = this;
        ios_fix_js_1.default.init();
        document.body.addEventListener("touchstart", function () {
            ios_fix_js_1.default.handler();
            _this.iosFixed = true;
        }, false);
        document.body.addEventListener("touchend", function () {
            ios_fix_js_1.default.handler();
            _this.iosFixed = true;
        }, false);
    };
    CanvasPlayer.prototype.initializeOptions = function () {
        var preloadImages = this.options.preloadImages === undefined ? true : this.options.preloadImages;
        (0, customevent_ie_js_1.customEventPolyFill)();
        // Setting the width and height of the player
        this.width = this.animationProperties.width;
        this.height = this.animationProperties.height;
        this.autoplay = typeof this.options.autoplay !== "boolean" ? true : this.options.autoplay;
        // Grabs the rootName used for initializing the exportRoot
        this.rootName =
            this.options.rootName ||
                Object.keys(this.animationLibrary)[Object.keys(this.animationLibrary).indexOf("properties") - 1];
        this.ended = false;
        this.progress = 0;
        this.pixelDensity = this.options.pixelDensity || 1;
        this.audioClips = [];
        this.manifest = this.animationProperties.manifest;
        if (!preloadImages) {
            this.manifest = this.manifest.filter(function (asset) {
                return !/\.(jpg|jpeg|png|gif)$/i.test(asset.src);
            });
        }
        this.totalNumFiles = this.manifest.length;
        this.canvas = this.container.querySelector("canvas");
        this.domOverlay = this.container.querySelector(".cp-overlay") || null;
        var containerWidth = this.container.offsetWidth;
        var containerHeight = this.container.offsetHeight;
        var widthFactor = containerWidth / this.width;
        var heightFactor = containerHeight / this.height;
        var factor = Math.min(widthFactor, heightFactor);
        var viewWidth = factor * this.width;
        var viewHeight = factor * this.height;
        var pixelDensity = this.pixelDensity || 1;
        if (this.options.videoSize) {
            this.canvas.width = this.options.videoSize.width;
            this.canvas.height = this.options.videoSize.height;
        }
        else {
            this.canvas.width = viewWidth * pixelDensity;
            this.canvas.height = viewHeight * pixelDensity;
        }
        if (this.domOverlay) {
            this.domOverlay.style.width = viewWidth + "px";
            this.domOverlay.style.height = viewHeight + "px";
        }
        this.enableCC = this.options.enableCC === undefined ? false : this.options.enableCC;
        this.captions = [];
        this.captionGrabCompleted = false;
        this.descriptions = [];
        this.descriptionGrabCompleted = false;
        if (this.options.backgroundMusic) {
            if (this.options.backgroundMusic.soundClipID) {
                this.backgroundMusicSoundClipID = this.options.backgroundMusic.soundClipID;
            }
        }
    };
    CanvasPlayer.prototype.createTemplate = function (fonts) {
        var fragment = document.createDocumentFragment();
        var div = document.createElement("div");
        // sanitize width and height for when rmlib compiles these string literals to concat() functions
        var width = String(this.animationProperties.width).replace(/\D/g, "");
        var height = String(this.animationProperties.height).replace(/\D/g, "");
        var canvasHTML = "<canvas width=\"".concat(width, "\" height=\"").concat(height, "\"></canvas>");
        var overlayHTML = this.options.domOverlay
            ? "<div class=\"cp-overlay\" style=\"pointer-events:none; overflow:hidden; width:".concat(width, "px; height:").concat(height, "px; position: absolute; left: 0px; top: 0px; display: block;\"></div>")
            : "";
        var fontHTML = '<div class="font-preload" aria-hidden="true">' + fonts.map(this.createFontTemplate).join("") + "</div>";
        div.innerHTML = canvasHTML + overlayHTML + fontHTML;
        while (div.firstChild) {
            fragment.appendChild(div.firstChild);
        }
        return fragment;
    };
    CanvasPlayer.prototype.createFontTemplate = function (font) {
        font = font.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        return "<div style=\"font-family: ".concat(font, ";\">preload</div>");
    };
    CanvasPlayer.prototype.handleFileLoad = function (event) {
        this.progress += 1 / this.totalNumFiles;
        this.dispatchEvent("progress");
        if (event && event.item.type === "image") {
            this.animationImages[event.item.id] = event.result;
        }
    };
    CanvasPlayer.prototype.handleAnimationLoad = function (animations) {
        var _this = this;
        // Loading the manifest for each specific dynamic timeline
        var promises = animations.map(function (anim) {
            return new Promise(function (resolve) {
                // Get each animation timeline's image object and library
                var images = anim.composition.getImages();
                var library = anim.composition.getLibrary();
                var imagesArray = [];
                var soundsArray = [];
                // Create a new loader for each animation
                var loader = new createjs_1.default.LoadQueue(false);
                loader.installPlugin(createjs_1.default.Sound);
                loader.setMaxConnections(6);
                loader.on("fileload", function (event) {
                    _this.progress += 1 / _this.totalNumFiles;
                    _this.dispatchEvent("progress");
                    if (event && event.item.type === "image") {
                        images[event.item.id] = event.result;
                    }
                });
                loader.on("complete", function () {
                    resolve(null);
                });
                if (library.properties.loaded === undefined || library.properties.loaded === false) {
                    imagesArray = library.properties.manifest.filter(function (asset) { return asset.src[asset.src.length - 1] !== "3"; });
                    library.properties.loaded = true;
                }
                soundsArray = library.properties.manifest.filter(function (asset) { return asset.src[asset.src.length - 1] === "3" &&
                    (createjs_1.default.Sound.activePlugin
                        ? !createjs_1.default.Sound.activePlugin.isPreloadComplete(asset.src)
                        : true); });
                if (imagesArray.length === 0 && soundsArray.length === 0) {
                    resolve(null);
                }
                loader.loadManifest(__spreadArray(__spreadArray([], imagesArray, true), soundsArray, true));
            });
        });
        try {
            Promise.all(promises).then(this.handleComplete.bind(this));
        }
        catch (e) {
            console.log(e);
        }
    };
    CanvasPlayer.prototype.createStage = function () {
        if (this.options.webgl)
            return new createjs_1.default.StageGL(this.canvas, { antialias: true });
        if (typeof this.animationLibrary.Stage === "function")
            return new this.animationLibrary.Stage(this.canvas);
        return new createjs_1.default.Stage(this.canvas);
    };
    CanvasPlayer.prototype.handleComplete = function () {
        var _this = this;
        this.progress = 1;
        this.dispatchEvent("progress");
        this.canvas.style.display = "block";
        createjs_1.default.Ticker.framerate = this.animationProperties.fps;
        createjs_1.default.Ticker.timingMode =
            this.options.timingMode ||
                (this.options.webgl ? CanvasPlayer.TIMING.RAF_SYNCHED : CanvasPlayer.TIMING.TIMEOUT);
        createjs_1.default.Ticker.addEventListener("tick", this.tickHandler);
        this.stage = this.createStage();
        if (this.options.webgl)
            this.stage.setClearColor(this.options.clearColor || "rgba(255, 255, 255, 0.0)");
        this.stage.autoClear = true;
        var pixelDensity = this.pixelDensity || 1;
        this.stage.pixelDensity = pixelDensity;
        if (this.options.stageVars) {
            this.stage.stageVars = this.options.stageVars;
            this.stageVars = this.options.stageVars;
        }
        if (this.domOverlay) {
            this.stage.domOverlay = this.domOverlay;
        }
        this.initExportRoot();
        this.exportRoot.stop();
        this.updateStage();
        this.dispatchEvent("durationchange");
        setTimeout(function () {
            _this.dispatchEvent("canplay");
            _this.dispatchEvent("tick");
            if (_this.autoplay) {
                _this.play();
            }
            else {
                _this.audioClips.forEach(function (clip) {
                    clip.soundInstance.paused = true;
                });
                _this.dispatchEvent("pause");
            }
        });
    };
    CanvasPlayer.prototype.loadChildrenLibraries = function () {
        var childrenLibraries = [];
        if (this.options.dynamicTimeline === undefined || this.options.dynamicTimeline.length === 0) {
            throw new Error("No dynamic Timeline provided!");
        }
        var sceneIds = [];
        this.options.dynamicTimeline.forEach(function (scene) {
            if (typeof scene === "string") {
                sceneIds.push(scene);
            }
            else {
                sceneIds.push(scene.id);
            }
        });
        var sortedAnimations = this.animation
            .filter(function (anim) { return sceneIds.indexOf(anim.meta.TITLE) !== -1; })
            .sort(function (anim1, anim2) {
            return sceneIds.indexOf(anim1.meta.TITLE) - sceneIds.indexOf(anim2.meta.TITLE);
        });
        sortedAnimations.forEach(function (anim) {
            if (sceneIds.indexOf(anim.meta.TITLE) !== -1) {
                var childLib = anim.composition.getLibrary();
                childrenLibraries.push(childLib);
            }
        });
        if (childrenLibraries.length === 0) {
            throw new Error("No Children Libraries available!");
        }
        // Generate dynamic timeline library
        this.animationLibrary = this.generateLibForDynamicTimelines(childrenLibraries, sceneIds);
    };
    CanvasPlayer.prototype.updateStage = function () {
        this.stage.tickOnUpdate = false;
        this.stage.update();
        this.stage.tickOnUpdate = true;
    };
    CanvasPlayer.prototype.handleResize = function () {
        createjs_1.default.Ticker.paused = true;
        this.handleResizeDebounced();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CanvasPlayer.prototype.handlePlayerResize = function (_forceResize) {
        if (_forceResize === void 0) { _forceResize = false; }
        if (this.exportRoot !== undefined) {
            var containerWidth = this.container.offsetWidth;
            var containerHeight = this.container.offsetHeight;
            var widthFactor = containerWidth / this.width;
            var heightFactor = containerHeight / this.height;
            var factor = Math.min(widthFactor, heightFactor);
            var viewWidth = factor * this.width;
            var viewHeight = factor * this.height;
            var pixelDensity = this.pixelDensity || 1;
            if (this.options.videoSize) {
                this.canvas.width = this.options.videoSize.width;
                this.canvas.height = this.options.videoSize.height;
            }
            else {
                this.canvas.width = viewWidth * pixelDensity;
                this.canvas.height = viewHeight * pixelDensity;
            }
            if (this.options.width) {
                this.canvas.style.width =
                    typeof this.options.width === "string" ? this.options.width : this.options.width(viewWidth);
            }
            else {
                this.canvas.style.width = "".concat(viewWidth, "px");
            }
            if (this.options.height) {
                this.canvas.style.height =
                    typeof this.options.height === "string" ? this.options.height : this.options.height(viewHeight);
            }
            else {
                this.canvas.style.height = "".concat(viewHeight, "px");
            }
            this.canvas.style.left = Math.round((containerWidth - viewWidth) / 2) + "px";
            this.canvas.style.top = Math.round((containerHeight - viewHeight) / 2) + "px";
            if (this.domOverlay) {
                this.domOverlay.style.width = viewWidth * pixelDensity + "px";
                this.domOverlay.style.height = viewHeight * pixelDensity + "px";
                this.domOverlay.style.left = this.canvas.style.left;
                this.domOverlay.style.top = this.canvas.style.top;
                this.domOverlay.style.fontSize = "".concat(Math.round(factor * pixelDensity * 100).toFixed(5), "px");
                this.domOverlay.style.transform = "scale(".concat((1 / pixelDensity).toFixed(5), ")");
                this.domOverlay.style.transformOrigin = "top left";
            }
            if (this.options.webgl) {
                this.stage.updateViewport(this.canvas.width, this.canvas.height);
            }
            else {
                this.exportRoot.setTransform(0, 0, factor * pixelDensity, factor * pixelDensity);
            }
            this.stage.pixelDensity = pixelDensity;
            createjs_1.default.Ticker.paused = false;
            if (this.paused) {
                this.updateStage();
            }
            this.dispatchEvent("resizeEnd");
        }
    };
    CanvasPlayer.prototype.createExportRoot = function () {
        var C;
        if (this.options.dynamicTimeline === undefined) {
            C = this.animationLibrary[this.rootName];
        }
        else {
            C = this.animationLibrary.main;
        }
        return new C(createjs_1.default.MovieClip.INDEPENDENT, 0, 0);
    };
    CanvasPlayer.prototype.initExportRoot = function () {
        var _this = this;
        this.exportRoot = this.createExportRoot();
        this.audioClips = [];
        if (this.exportRoot.dynamicScenes === undefined || this.exportRoot.dynamicScenes.length === 0) {
            this.grabAudio(this.exportRoot, 0);
            if (this.enableCC) {
                this.grabCaptionsFromAnimation(false);
                this.grabDescriptions(false);
            }
        }
        else {
            this.exportRoot.dynamicScenes.forEach(function (scene) {
                _this.grabAudio(scene.inst, scene.startFrame);
            });
            if (this.enableCC) {
                this.grabCaptionsFromAnimation(true);
                this.grabDescriptions(true);
            }
        }
        this.stage.addChild(this.exportRoot);
        this.exportRoot.framerate = this.animationProperties.fps;
        this.dispatchEvent("exportRootCreated");
        this.handlePlayerResize();
    };
    CanvasPlayer.prototype.grabCaptionsFromAnimation = function (hasDynamicTimeline) {
        var _this = this;
        if (!hasDynamicTimeline) {
            var ccPropNames_1 = Object.keys(this.exportRoot).filter(function (property) {
                return property.startsWith("caption");
            });
            var captionTweens = this.exportRoot.timeline.tweens.filter(function (tween) {
                return ccPropNames_1.some(function (propName) {
                    if (tween.target === _this.exportRoot[propName]) {
                        return true;
                    }
                });
            });
            captionTweens.forEach(function (captionTween) {
                var cur = captionTween._stepHead;
                while (cur !== null && !_this.captionGrabCompleted) {
                    if (Object.keys(cur).length === 0 || cur.props.text === undefined) {
                        _this.captions.push({
                            startFrame: cur.t + cur.d,
                            off: cur.props._off === undefined || cur.props._off === null ? false : cur.props._off,
                            text: captionTween.target.text,
                        });
                    }
                    else {
                        _this.captions.push({
                            startFrame: cur.t + cur.d,
                            off: cur.props._off,
                            text: cur.props.text,
                        });
                    }
                    var startTime = cur.t / _this.animationProperties.fps;
                    var duration = cur.d / _this.animationProperties.fps;
                    if (Object.keys(cur).length === 0 || cur.props.text === undefined) {
                        _this.descriptions.push({
                            startTime: startTime,
                            duration: duration,
                            text: captionTween.target.text,
                            type: "caption",
                            off: cur.props._off === undefined || cur.props._off === null ? false : cur.props._off,
                        });
                    }
                    else {
                        _this.descriptions.push({
                            startTime: startTime,
                            duration: duration,
                            text: cur.props.text,
                            type: "caption",
                            off: cur.props._off,
                        });
                    }
                    cur = cur.next;
                }
                _this.exportRoot.timeline.removeTween(captionTween);
            });
            ccPropNames_1.forEach(function (name) {
                _this.exportRoot[name] = undefined;
            });
        }
        else {
            var ccPropNames_2 = [];
            this.exportRoot.dynamicScenes.forEach(function (scene) {
                var keys = Object.keys(scene.inst);
                var key = keys.filter(function (property) {
                    return property.startsWith("caption");
                })[0];
                ccPropNames_2.push(key);
            });
            var firstStartFrame_1 = 0;
            this.exportRoot.dynamicScenes.forEach(function (scene) {
                var captionTweens = scene.inst.timeline.tweens.filter(function (tween) {
                    return ccPropNames_2.some(function (propName) {
                        if (tween.target === scene.inst[propName]) {
                            return true;
                        }
                    });
                });
                captionTweens.forEach(function (captionTween) {
                    var cur = captionTween._stepHead;
                    while (cur !== null && !_this.captionGrabCompleted) {
                        if (Object.keys(cur).length === 0 || cur.props.text === undefined) {
                            _this.captions.push({
                                startFrame: cur.t + cur.d + firstStartFrame_1,
                                text: captionTween.target.text,
                                off: cur.props._off === undefined || cur.props._off === null ? false : cur.props._off,
                            });
                        }
                        else {
                            _this.captions.push({
                                startFrame: cur.t + cur.d + firstStartFrame_1,
                                text: cur.props.text,
                                off: cur.props._off,
                            });
                        }
                        var startTime = (cur.t + firstStartFrame_1) / _this.animationProperties.fps;
                        var duration = cur.d / _this.animationProperties.fps;
                        if (Object.keys(cur).length === 0 || cur.props.text === undefined) {
                            _this.descriptions.push({
                                startTime: startTime,
                                duration: duration,
                                text: captionTween.target.text,
                                type: "caption",
                                off: cur.props._off === undefined || cur.props._off === null ? false : cur.props._off,
                            });
                        }
                        else {
                            _this.descriptions.push({
                                startTime: startTime,
                                duration: duration,
                                text: cur.props.text,
                                type: "caption",
                                off: cur.props._off,
                            });
                        }
                        cur = cur.next;
                    }
                    firstStartFrame_1 += scene.duration;
                    scene.inst.timeline.removeTween(captionTween);
                });
            });
            this.exportRoot.dynamicScenes.forEach(function (scene) {
                ccPropNames_2.forEach(function (ccpropName) {
                    if (scene.inst[ccpropName] !== undefined) {
                        scene.inst[ccpropName] = undefined;
                    }
                });
            });
        }
        this.captions.sort(function (caption1, caption2) { return caption1.startFrame - caption2.startFrame; });
        this.captionGrabCompleted = true;
    };
    CanvasPlayer.prototype.grabDescriptions = function (hasDynamicTimeline) {
        var _this = this;
        if (!hasDynamicTimeline) {
            var descPropNames_1 = Object.keys(this.exportRoot).filter(function (property) {
                return property.startsWith("description");
            });
            var descriptionTweens = this.exportRoot.timeline.tweens.filter(function (tween) {
                return descPropNames_1.some(function (propName) {
                    if (tween.target === _this.exportRoot[propName]) {
                        return true;
                    }
                });
            });
            descriptionTweens.forEach(function (descTween) {
                var cur = descTween._stepHead;
                while (cur !== null && !_this.descriptionGrabCompleted) {
                    var startTime = cur.t / _this.animationProperties.fps;
                    var duration = cur.d / _this.animationProperties.fps;
                    if (Object.keys(cur).length === 0 || cur.props.text === undefined) {
                        _this.descriptions.push({
                            startTime: startTime,
                            duration: duration,
                            text: descTween.target.text,
                            off: cur.props._off === undefined || cur.props._off === null ? false : cur.props._off,
                            type: "description",
                        });
                    }
                    else {
                        _this.descriptions.push({
                            startTime: startTime,
                            duration: duration,
                            text: cur.props.text,
                            off: cur.props._off,
                            type: "description",
                        });
                    }
                    cur = cur.next;
                }
                _this.exportRoot.timeline.removeTween(descTween);
            });
            descPropNames_1.forEach(function (name) {
                _this.exportRoot[name] = undefined;
            });
        }
        else {
            var descPropNames_2 = [];
            this.exportRoot.dynamicScenes.forEach(function (scene) {
                var keys = Object.keys(scene.inst);
                var key = keys.filter(function (property) {
                    return property.startsWith("description");
                })[0];
                descPropNames_2.push(key);
            });
            var firstStartFrame_2 = 0;
            this.exportRoot.dynamicScenes.forEach(function (scene) {
                var descriptionTweens = scene.inst.timeline.tweens.filter(function (tween) {
                    return descPropNames_2.some(function (propName) {
                        if (tween.target === scene.inst[propName]) {
                            return true;
                        }
                    });
                });
                descriptionTweens.forEach(function (descTween) {
                    var cur = descTween._stepHead;
                    while (cur !== null && !_this.descriptionGrabCompleted) {
                        var startTime = (cur.t + firstStartFrame_2) / _this.animationProperties.fps;
                        var duration = cur.d / _this.animationProperties.fps;
                        if (Object.keys(cur).length === 0 || cur.props.text === undefined) {
                            _this.descriptions.push({
                                startTime: startTime,
                                duration: duration,
                                text: descTween.target.text,
                                off: cur.props._off === undefined || cur.props._off === null ? false : cur.props._off,
                                type: "description",
                            });
                        }
                        else {
                            _this.descriptions.push({
                                startTime: startTime,
                                duration: duration,
                                text: cur.props.text,
                                off: cur.props._off,
                                type: "description",
                            });
                        }
                        cur = cur.next;
                    }
                    firstStartFrame_2 += scene.duration;
                    scene.inst.timeline.removeTween(descTween);
                });
            });
        }
        this.descriptions.sort(function (desc1, desc2) {
            if (desc1.startTime === desc2.startTime && desc1.type === "caption" && desc2.type === "description") {
                return 1;
            }
            return desc1.startTime - desc2.startTime;
        });
        this.descriptionGrabCompleted = true;
    };
    CanvasPlayer.prototype.generateTranscript = function () {
        return this.descriptions;
    };
    CanvasPlayer.prototype.grabAudio = function (clip, startFrame) {
        var _this = this;
        if (this.options.nativeAudio)
            return;
        var movieClipProp, soundInstance;
        Object.keys(clip).forEach(function (key) {
            movieClipProp = clip[key];
            if (typeof movieClipProp === "function") {
                var soundIds = (movieClipProp.toString().match(/playSound\("([^"]+)"/g) || []).map(function (m) { return m.replace(/^playSound\("/, "").replace(/"$/, ""); });
                soundIds.forEach(function (idString) {
                    soundInstance = createjs_1.default.Sound.createInstance(idString);
                    var audioClip = {
                        startFrame: parseInt(key.toString().split("_")[1]) + startFrame,
                        id: idString,
                        duration: soundInstance.duration,
                        soundInstance: soundInstance,
                    };
                    if (_this.backgroundMusicSoundClipID &&
                        audioClip.id === _this.backgroundMusicSoundClipID &&
                        !_this.backgroundMusicSoundClip) {
                        _this.backgroundMusicSoundClip = audioClip;
                    }
                    var includeClip = true;
                    if (typeof _this.options.filterSoundClip === "function") {
                        includeClip = _this.options.filterSoundClip(audioClip);
                    }
                    if (includeClip) {
                        _this.audioClips.push(audioClip);
                    }
                });
            }
        });
    };
    CanvasPlayer.prototype.fullScreenChange = function () {
        var document = window.document;
        var fullScreenElement = document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement;
        var fullScreenEnabled = document.fullscreenEnabled ||
            document.mozFullScreenEnabled ||
            document.webkitFullscreenEnabled ||
            document.msFullscreenEnabled;
        if (this.fullScreen && (!fullScreenEnabled || fullScreenElement !== this.container)) {
            this.fullScreen = false;
            this.dispatchEvent("fullscreenchange");
            this.container.classList.remove("fullscreen-on");
        }
        else if (!this.fullScreen && fullScreenEnabled && fullScreenElement === this.container) {
            this.fullScreen = true;
            this.dispatchEvent("fullscreenchange");
            this.container.classList.add("fullscreen-on");
        }
    };
    CanvasPlayer.prototype.updateStageVars = function (newVars) {
        this.stage.stageVars = newVars;
        this.stageVars = newVars;
    };
    CanvasPlayer.prototype.destroy = function () {
        // Removing event listeners
        window.removeEventListener("resize", this.resizeFunc);
        createjs_1.default.Ticker.removeEventListener("tick", this.tickHandler);
        document.removeEventListener("fullscreenchange", this.fullScreenFunc);
        document.removeEventListener("mozfullscreenchange", this.fullScreenFunc);
        document.removeEventListener("webkitfullscreenchange", this.fullScreenFunc);
        document.removeEventListener("MSFullscreenChange", this.fullScreenFunc);
        // Removing the canvas element ! Removing this for now for testing purposes
        // this.container.removeChild(this.canvas);
        // Stopping the exportRoot and all audioClips
        this.audioClips.forEach(function (clip) {
            clip.soundInstance.stop();
        });
        this.exportRoot.stop();
        this.exportRoot = undefined;
        this.stage.enableMouseOver(-1);
        this.stage.enableDOMEvents(false);
        this.stage.removeAllEventListeners();
        this.stage.removeAllChildren();
        this.stage.canvas = null;
        this.stage = null;
    };
    CanvasPlayer.prototype.loopThroughAudio = function (frameNum, seeking) {
        var _this = this;
        var frameDuration;
        var fps = this.animationProperties.fps;
        this.audioClips.forEach(function (clip) {
            frameDuration = clip.duration / fps;
            if (seeking) {
                clip.played = false;
            }
            if (frameNum >= clip.startFrame && frameNum < clip.startFrame + frameDuration) {
                if (!clip.played) {
                    clip.played = true;
                    clip.soundInstance.position = ((frameNum - clip.startFrame) * 1000) / fps;
                    if (!_this.paused) {
                        clip.soundInstance.play();
                    }
                }
                else if (seeking) {
                    clip.soundInstance.position = ((frameNum - clip.startFrame) * 1000) / fps;
                }
            }
            else if (typeof clip.soundInstance !== "undefined") {
                clip.soundInstance.stop();
            }
        });
        return true;
    };
    CanvasPlayer.prototype.fadeOutBackgroundMusic = function () {
        var fps = this.animationProperties.fps;
        var fadeOut = this.options.backgroundMusic && this.options.backgroundMusic.fadeOut;
        var fadeOutDuration = this.options.backgroundMusic && typeof this.options.backgroundMusic.fadeOutDuration === "number"
            ? this.options.backgroundMusic.fadeOutDuration
            : 5;
        fadeOutDuration *= fps;
        if (fadeOut && this.backgroundMusicSoundClip) {
            if (this.getTotalFrames() - this.exportRoot.currentFrame <= fadeOutDuration) {
                this.backgroundMusicSoundClip.soundInstance.volume -= 1 / fadeOutDuration;
            }
            else {
                this.backgroundMusicSoundClip.soundInstance.volume = 1;
            }
        }
    };
    CanvasPlayer.prototype.play = function () {
        this.exportRoot.play();
        if (this.noSleepInstance) {
            this.noSleepInstance.enable();
        }
        if (this.ended) {
            this.ended = false;
            this.audioClips.forEach(function (clip) {
                clip.played = false;
            });
            try {
                this.stage.removeChild(this.exportRoot);
            }
            catch (e) {
                console.error("Error: ", e);
            }
            this.initExportRoot();
            this.dispatchEvent("play");
        }
        else {
            this.audioClips.forEach(function (clip) {
                clip.played = false;
                clip.soundInstance.paused = false;
            });
            this.dispatchEvent("play");
        }
    };
    CanvasPlayer.prototype.pause = function () {
        if (this.paused === false) {
            this.exportRoot.stop();
            if (this.noSleepInstance)
                this.noSleepInstance.disable();
            this.audioClips.forEach(function (clip) {
                clip.played = false;
                clip.soundInstance.paused = true;
            });
            this.dispatchEvent("pause");
        }
    };
    CanvasPlayer.prototype.goToFrame = function (frameNum) {
        var movieClipFrame;
        if (this.paused) {
            this.exportRoot.gotoAndStop(frameNum);
        }
        else {
            this.exportRoot.gotoAndPlay(frameNum);
        }
        if (this.exportRoot.dynamicScenes !== undefined && this.exportRoot.dynamicScenes.length === 0) {
            this.exportRoot.dynamicScenes.forEach(function (dynamicScene) {
                if (!dynamicScene.background &&
                    frameNum >= dynamicScene.startFrame &&
                    frameNum < dynamicScene.startFrame + dynamicScene.duration) {
                    movieClipFrame = frameNum - dynamicScene.startFrame;
                    if (dynamicScene.inst.paused) {
                        dynamicScene.inst.gotoAndStop(movieClipFrame);
                    }
                    else {
                        dynamicScene.inst.gotoAndPlay(movieClipFrame);
                    }
                }
            });
        }
        if (this.paused) {
            this.updateStage();
        }
        this.loopThroughAudio(frameNum, true);
        if (this.enableCC) {
            for (var i = 0; i < this.captions.length; i++) {
                if (this.exportRoot.currentFrame >= this.captions[i].startFrame) {
                    this.currentCaptionsReference = this.captions[i];
                    var event = new CustomEvent("captionChanged", {
                        detail: this.currentCaptionsReference,
                    });
                    this.dispatchEvent(event);
                }
            }
        }
    };
    CanvasPlayer.prototype.restart = function () {
        this.ended = false;
        this.exportRoot.play();
        this.audioClips.forEach(function (clip) {
            clip.soundInstance.stop();
        });
        try {
            this.stage.removeChild(this.exportRoot);
        }
        catch (e) {
            console.error("Error: ", e);
        }
        this.initExportRoot();
        this.dispatchEvent("play");
    };
    CanvasPlayer.prototype.getDuration = function () {
        return Math.round(this.exportRoot.duration / this.animationProperties.fps);
    };
    CanvasPlayer.prototype.getCurrentTime = function () {
        return Math.round((20 * this.exportRoot.currentFrame) / this.animationProperties.fps) / 20;
    };
    CanvasPlayer.prototype.getTotalFrames = function () {
        return this.exportRoot.duration;
    };
    CanvasPlayer.prototype.toggleFullscreen = function () {
        var document = window.document;
        var fullScreenEnabled = document.fullscreenEnabled ||
            document.mozFullScreenEnabled ||
            document.webkitFullscreenEnabled ||
            document.msFullscreenEnabled;
        if (fullScreenEnabled) {
            createjs_1.default.Ticker.paused = true;
            this.handleResizeDebounced();
            var container = this.container;
            var requestFullScreen = container.requestFullscreen ||
                container.mozRequestFullScreen ||
                container.msRequestFullscreen ||
                container.webkitRequestFullscreen;
            var exitFullScreen = document.exitFullscreen ||
                document.mozCancelFullScreen ||
                document.msExitFullscreen ||
                document.webkitExitFullscreen;
            if (this.fullScreen) {
                exitFullScreen.call(document);
            }
            else {
                requestFullScreen.call(container);
            }
        }
    };
    CanvasPlayer.prototype.isFullscreen = function () {
        return this.fullScreen;
    };
    CanvasPlayer.prototype.isCC = function () {
        return this.enableCC;
    };
    CanvasPlayer.prototype.getProgress = function () {
        return this.progress;
    };
    CanvasPlayer.prototype.goToScene = function (scene) {
        var sceneId = typeof scene !== "string" ? scene.id : scene;
        var dynamicScene = this.exportRoot.dynamicScenes.filter(function (dynamicScene) {
            return dynamicScene.id === sceneId;
        })[0];
        if (!dynamicScene) {
            return;
        }
        this.goToFrame(dynamicScene.startFrame);
    };
    CanvasPlayer.prototype.reflow = function (sceneList, options) {
        if (!sceneList || sceneList.length === 0) {
            throw new Error("No scenelist provided!");
        }
        this.options.dynamicTimeline = sceneList;
        this.loadChildrenLibraries();
        this.exportRoot.stop();
        // Recapture captions and descriptions
        this.captions = [];
        this.descriptions = [];
        this.captionGrabCompleted = false;
        this.descriptionGrabCompleted = false;
        // Initialize the ExportRoot
        this.initExportRoot();
        // This removes the previous ExportRoot from the stage and adds
        // the newly created one
        this.stage.removeAllChildren();
        this.stage.addChild(this.exportRoot);
        this.exportRoot.stop();
        this.updateStage();
        // If both scene and frameNums are provided then jumping to the specified scene
        // takes priority
        if (options) {
            if (options.scene) {
                this.goToScene(options.scene);
            }
            else if (options.frameNum) {
                this.goToFrame(options.frameNum);
            }
        }
        this.dispatchEvent("canplay");
    };
    CanvasPlayer.prototype.canAutoPlay = function () {
        if (this.isIOS && this.iosFixed) {
            return true;
        }
        return false;
    };
    CanvasPlayer.prototype.getAudioById = function (id) {
        for (var i = 0; i < this.audioClips.length; i++) {
            var clip = this.audioClips[i];
            if (clip.id === id) {
                return clip;
            }
        }
        return null;
    };
    CanvasPlayer.prototype.generateLibForDynamicTimelines = function (children, sceneIds) {
        var fps = children[0].properties.fps;
        for (var i = 0, l = children.length; i < l; i++) {
            if (children[i].properties.fps !== fps) {
                throw new Error("Scene \"".concat(sceneIds[i], "\" has a different fps: ").concat(children[i].properties.fps));
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var cp = this;
        var newLibrary = {
            properties: {
                width: 1920,
                height: 1080,
                fps: fps,
                color: "#FFFFFF",
                opacity: 1.0,
                manifest: children.reduce(function (manifest, child) {
                    return manifest.concat(child.properties.manifest);
                }, []),
            },
            main: function (mode, startPosition, loop) {
                var _this = this;
                this.initialize(mode, startPosition, loop, {});
                var childClips = [];
                var currentFrame = 0;
                var totalDuration = 0;
                this.dynamicLabels = [];
                this._updateTimeline = function (rawPosition, jump) {
                    var tl = this.timeline;
                    if (rawPosition < 0) {
                        rawPosition = 0;
                    }
                    if (this._rawPosition === rawPosition) {
                        return;
                    }
                    this._rawPosition = rawPosition;
                    // update timeline position, ignoring actions if this is a graphic.
                    tl.loop = this.loop; // TODO: should we maintain this on MovieClip, or just have it on timeline?
                    tl.setPosition(rawPosition, !this.actionsEnabled, jump, this._bound_resolveState);
                    for (var i = 0; i < children.length; i++) {
                        var childClip = childClips[i];
                        childClip._updateTimeline(rawPosition - childClip.startFrame, jump);
                    }
                };
                for (var i = 0; i < children.length; i++) {
                    var C = CanvasPlayer.getExportRoot(children[i]);
                    var childClip = new C("independent", 0, 0);
                    childClip.parent = this;
                    childClips.push(childClip);
                    childClip.startFrame = currentFrame;
                    Object.defineProperty(childClip, "_off", {
                        get: function () {
                            return this.__off;
                        },
                        set: function (v) {
                            this.__off = v;
                            if (this.__off && Interfaces.isEnhancedRootMovieClip(this)) {
                                this.clearAllSoundStreams();
                            }
                        },
                    });
                    childClip.stop = function () {
                        cp.pause();
                    };
                    childClip.play = function () {
                        cp.play();
                    };
                    fakeSynced(childClip, currentFrame);
                    currentFrame += childClip.duration;
                    totalDuration += childClip.duration;
                }
                var _loop_1 = function (i) {
                    var childClip = childClips[i];
                    var tween = createjs_1.default.Tween.get(childClip);
                    var endTime = childClip.startFrame + childClip.duration;
                    if (i > 0) {
                        childClip._off = true;
                        tween.to({ _off: false }, childClip.startFrame);
                    }
                    else {
                        childClip._off = false;
                    }
                    if (totalDuration - endTime <= 0) {
                        tween.wait(childClip.duration);
                    }
                    else {
                        tween.to({ _off: true }, childClip.duration);
                        tween.wait(totalDuration - endTime);
                    }
                    childClip.dynamicLabels = childClip.labels.map(function (label) { return (__assign(__assign({}, label), { position: childClip.startFrame + label.position })); });
                    this_1.timeline.addTween(tween);
                    this_1.dynamicLabels = __spreadArray(__spreadArray([], this_1.dynamicLabels, true), childClip.dynamicLabels, true);
                };
                var this_1 = this;
                for (var i = 0; i < children.length; i++) {
                    _loop_1(i);
                }
                this.dynamicScenes = [];
                childClips.forEach(function (childClip, index) {
                    _this.dynamicScenes.push({
                        id: sceneIds[index],
                        startFrame: childClip.startFrame,
                        duration: childClip.duration,
                        inst: childClip,
                    });
                });
                this.stop = function () {
                    createjs_1.default.MovieClip.prototype.stop.call(_this);
                    childClips.forEach(function (c) {
                        if (Interfaces.isEnhancedRootMovieClip(c))
                            c.clearAllSoundStreams();
                    });
                };
                this.gotoAndStop = function (positionOrLabel) {
                    createjs_1.default.MovieClip.prototype.gotoAndStop.call(_this, positionOrLabel);
                    childClips.forEach(function (c) {
                        if (Interfaces.isEnhancedRootMovieClip(c))
                            c.clearAllSoundStreams();
                    });
                };
                this.play = function () {
                    childClips.forEach(function (c) {
                        if (Interfaces.isEnhancedRootMovieClip(c)) {
                            c.clearAllSoundStreams();
                            c.startStreamSoundsForTargetedFrame(_this.currentFrame - c.startFrame);
                        }
                    });
                    createjs_1.default.MovieClip.prototype.play.call(_this);
                };
                this.gotoAndPlay = function (positionOrLabel) {
                    var pos = _this.timeline.resolve(positionOrLabel);
                    if (pos != null) {
                        childClips.forEach(function (c) {
                            if (Interfaces.isEnhancedRootMovieClip(c)) {
                                c.clearAllSoundStreams();
                                c.startStreamSoundsForTargetedFrame(pos - c.startFrame);
                            }
                        });
                    }
                    createjs_1.default.MovieClip.prototype.gotoAndPlay.call(_this, positionOrLabel);
                };
                this.handleSoundTick = function () {
                    childClips.forEach(function (c) {
                        if (c._off)
                            return;
                        if (Interfaces.isEnhancedRootMovieClip(c)) {
                            c.stopSoundStreams(c.currentFrame);
                        }
                    });
                };
            },
        };
        newLibrary.main.prototype = new createjs_1.default.MovieClip();
        return newLibrary;
    };
    CanvasPlayer.getExportRoot = function (childLibrary) {
        var rootName = CanvasPlayer.getRootName(childLibrary);
        return childLibrary[rootName];
    };
    CanvasPlayer.getRootName = function (childLibrary) {
        var libKeys = Object.keys(childLibrary);
        return libKeys[libKeys.length - 3];
    };
    CanvasPlayer.loadAnimation = function (url, modName) {
        var base = document.baseURI;
        var newURL = new URL(url, base);
        url = newURL.href;
        var scriptSrc = newURL.href;
        if (animationCache[modName]) {
            return Promise.resolve(animationCache[modName]);
        }
        return new Promise(function (resolve) {
            var script = document.createElement("script");
            script.src = scriptSrc;
            script.onload = function () { return setTimeout(function () {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                var animation = require(modName).default;
                animationCache[modName] = animation;
                var library = animation.composition.getLibrary();
                library.properties.manifest.forEach(function (item) {
                    var newURL = new URL(item.src, url);
                    item.src = newURL.href;
                });
                resolve(animation);
            }); };
            document.head.appendChild(script);
        });
    };
    return CanvasPlayer;
}(createjs_1.default.EventDispatcher));
exports.CanvasPlayer = CanvasPlayer;
CanvasPlayer.TIMING = {
    RAF: "raf",
    RAF_SYNCHED: "synched",
    TIMEOUT: "timeout",
};
__exportStar(require("./interfaces"), exports);
exports.default = CanvasPlayer;
//# sourceMappingURL=index.js.map
//# sourceMappingURL=module.js.map